export default __webpack_public_path__ + "static/media/lane-2.c028a815.svg";